export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Crew.vue?vue&type=template&id=1cc472b2"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/Crew.vue?vue&type=template&id=1cc472b2
// module id = 1738
// module chunks = 31